module.exports = __webpack_public_path__ + "static/media/icon.45b3b31d.png";